export const ACCOUNT_SHOPS_ROUTE = "/account/shops";

export const ACCOUNT_SHOPS_NEW_ROUTE = `${ACCOUNT_SHOPS_ROUTE}/add`;
export const ACCOUNT_SHOPS_EDIT_ROUTE = `${ACCOUNT_SHOPS_ROUTE}/edit`;

export const ACCOUNT_SHOPS_SETTINGS_ROUTE = `${ACCOUNT_SHOPS_ROUTE}/settings`;
export const ACCOUNT_SHOPS_ADMIN_ROUTE = `${ACCOUNT_SHOPS_ROUTE}/admin`;
